import React from "react";
import { SectionPoster } from "../../shared/PosterTemplate";

const Statistics = ({parentPath}) =>
  <SectionPoster sectionName='statistics' backRoute={parentPath} />

export default Statistics;